import { inject, Pipe, PipeTransform } from '@angular/core';
import { TextResourceService } from '../services/text-resource.service';
import { Observable } from 'rxjs';

@Pipe({
  name: 'textResource',
  standalone: true,
})
export class TextResourcePipe implements PipeTransform {
  private readonly textResourceService = inject(TextResourceService);

  transform(value: any, args?: any): Observable<string> {
    return this.textResourceService.getFromJSON(
      'static/ewnioski/texts/resources.json',
      value,
    );
  }
}
